declare const c_FlashSaleDataPath: string;

export class LoadFlashsales {
  // Lade Flashsales
  public static async load(): Promise<Document> {
    const sessionData: string | null = sessionStorage.getItem("c_FlashsaleData");
    const parser = new DOMParser();

    if (sessionData !== null) {
      return parser.parseFromString(sessionData, "text/xml");
    } else {
      const fetchData = await fetch(c_FlashSaleDataPath);
      const fetchString = await fetchData.text();
      sessionStorage.setItem("c_FlashsaleData", fetchString);

      return parser.parseFromString(fetchString, "text/xml");
    }
  }
}
